import React from 'react';
import { useCommonTranslation } from 'c-translation';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@mui/material';
import type { DiscardChangesConfirmProps } from './useDiscardChangesGuard';

// Plain MUI Dialog rather than DialogV2: DialogV2 renders this one, so using it here would be a cycle.
const PaperProps = { sx: { borderRadius: 2.5 } };
const actionsSx = { justifyContent: 'center', pt: 2, pb: 4, px: 4 };

const DiscardChangesDialog: React.FC<DiscardChangesConfirmProps> = ({
    open,
    onKeepEditing,
    onDiscard,
}) => {
    const t = useCommonTranslation();
    return (
        <Dialog open={open} onClose={onKeepEditing} maxWidth="xs" fullWidth PaperProps={PaperProps}>
            <DialogTitle>
                <Typography variant="h3" component="span" display="block" textAlign="center">
                    {t('Dialog.discardChanges.title')}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText textAlign="center">
                    {t('Dialog.discardChanges.description')}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={actionsSx}>
                <Button onClick={onKeepEditing} autoFocus>
                    {t('Dialog.discardChanges.keepEditing')}
                </Button>
                <Button onClick={onDiscard} color="error">
                    {t('Dialog.discardChanges.discard')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DiscardChangesDialog;
